<!-- 选择商品 -->
<template>
  <div>
    <Sidebar v-model="activeKey" :dataList="dataList">
      <ProductCard v-for="(item,index) in baseDataList" :key="index" :datas="item" desc="sku" price="salesPrice" @change="changeNumber" />
    </Sidebar>
    <div class="bottom-box">
      <div>已选 <span style="color:#e1514c">{{ amountNumber }}</span> 件，共计¥<span style="color:#e1514c">{{ amountPrice }}</span> </div>
      <van-button type="primary" class="bottom-button" @click="submit" size="small" :disabled="!amountNumber">选好了</van-button>
    </div>
  </div>

</template>

<script>
import Sidebar from '@/components/common/Sidebar'
import ProductCard from '@/components/common/ProductCard'

export default {
  components: { Sidebar, ProductCard },
  data() {
    return {
      activeKey: '',
      dataList: [],
      baseDataList: [],
      selectedList: [],
      amountNumber: 0,
      amountPrice: 0,
    }
  },
  activated() {
    if (this.$route.params.clearData) {
      this.selectedList = []
    }
    this.getUseToClass()
    // 判断是否是驳回再次申请的单据
    if (this.$route.query.applyNo) {
      this.getDetailByStaff()
    }
  },
  watch: {
    activeKey(val) {
      this.baseDataList = []
      this.getProductByUseBaseClassId()
    },
    baseDataList(val) {
      this.showSelect()
    },
    selectedList() {
      // 计算总数
      this.amountNumber = 0
      this.amountPrice = 0
      this.selectedList.forEach((item) => {
        this.amountNumber += item.number
        this.amountPrice += item.number * item.salesPrice
      })
      this.showSelect()
    },
  },
  methods: {
    // 类型变化反显已选
    showSelect() {
      this.baseDataList.forEach((item) => {
        item.number = 0
        this.selectedList.forEach((i) => {
          if (i.id === item.id) {
            item.number = i.number
          }
        })
      })
    },
    // 获取单据详情
    getDetailByStaff() {
      let url = `/api-sys/sell/addMatterSearch/getDetailByStaff?staffId=${this.$store.state.userInfo.userId}&applyId=${this.$route.query.id}`
      this.$api.get(url).then((res) => {
        this.selectedList = res.data.details.map((item) => {
          return {
            code: item.productCode,
            id: item.tbBasicProductId,
            name: item.productName,
            number: item.realQuantity,
            salesPrice: item.price,
            sku: item.sku,
          }
        })
        // this.main = res.data
      })
    },
    changeNumber(data) {
      // 记录已选物流
      let isSelect = this.selectedList.some((item) => {
        return item.id === data.id
      })
      if (!isSelect) {
        this.selectedList.push(data)
      } else {
        this.selectedList.filter((i) => i.id === data.id)[0].number = data.number
      }
      // 清除为零的数据
      this.selectedList = this.selectedList.filter(i => i.number)
    },
    submit() {
      this.$utils.routerPush({
        name: 'ConfirmProduct',
        query: this.$route.query,
        params: {
          amountNumber: this.amountNumber,
          amountPrice: this.amountPrice,
          selectedList: this.selectedList,
        },
      })
    },
    // 获取分类
    getUseToClass() {
      this.$api.get('/api-sys/sell/sellMatter/getUseToClass?companyId=1170531430053449728').then((res) => {
        this.dataList = res.data
        if (this.dataList.length) {
          this.activeKey = this.dataList[0].id
        }
      })
    },
    // 获取分类下物料
    getProductByUseBaseClassId() {
      this.$api
        .post('/api-sys/sell/sellMatter/getProductByUseBaseClassId', {
          companyId: '1170531430053449728',
          classId: this.activeKey,
          pageNum: 1,
          pageSize: 10000,
        })
        .then((res) => {
          this.baseDataList = res.data.list.map((item) => {
            return {
              ...item,
              number: 0,
            }
          })
        })
    },
  },
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/view/DistributionApplication/SelectProduct.vue